import { MatDialog } from '@angular/material/dialog';
import { PopoverRef } from './../../../../components/popover/popover-ref';
import { Router } from '@angular/router';
import { GuiService } from 'src/app/services/gui.service';
import { Component, OnInit } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { DateTime } from 'luxon';
import { trackById } from '../../../../utils/track-by';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss']
})
export class ToolbarNotificationsDropdownComponent implements OnInit {

  flagAll: boolean = false;

  trackById = trackById;

  checkedIds:any = []

  constructor(public translate: TranslateService, public guiService : GuiService, public router: Router,public popover: PopoverRef, public dialog: MatDialog, private restService: RestService) { }

  ngOnInit() {
  }
}
